<template>
  <div class="land4">
    <header class="channel-code">渠道码：{{ channelCode }}</header>
    <main id="channel-page-html">
      <customLand v-if="showCustom" @hide="showCustom = false"></customLand>
      <template v-else>
        <!-- banner -->
        <div v-if="channelCode === 'worldfirst'" v-html="worldfirst"></div>
        <div v-else-if="channelCode === 'baiduKP'" v-html="baiduKP"></div>
        <div v-else-if="channelCode === 'ZINIAOeco'" v-html="ZINIAOeco"></div>
        <div v-else v-html="otherBanner"></div>
        <!-- 内容 -->
        <div v-html="content"></div>
      </template>
    </main>
    <RegisterBtn pageType="land4" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { mixinAddRegVisitLog } from '@/util/mixins'
import { mixinCheckResponseIsErr } from '@ost/static/lib/mixin'
import RegisterBtn from '@/components/RegisterBtn'
import { getCookie, getDeviceId } from '@/util/util'
import customLand from '@/components/customLand'
import {
  getChannelPageConfig,
  getPageConfigList,
  getRegisterAward
} from '@/api/land'
import { AWARD_TYPE } from '@/enum'

export default {
  naem: 'land4',
  components: {
    RegisterBtn,
    customLand
  },
  mixins: [mixinCheckResponseIsErr, mixinAddRegVisitLog],
  data () {
    return {
      showCustom: true,
      AWARD_TYPE,
      customData: {},
      registerPackage: [],
      channelCode: null // 渠道码
    }
  },
  computed: {
    ...mapState(['pageConfig']),
    worldfirst () {
      return this.pageConfig['ipp_common_land4_worldfirst'] || ''
    },
    baiduKP () {
      return this.pageConfig['ipp_common_land4_baiduKP'] || ''
    },
    ZINIAOeco () {
      return this.pageConfig['ipp_common_land4_ZINIAOeco'] || ''
    },
    otherBanner () {
      return this.pageConfig['ipp_common_land4_banner'] || ''
    },
    content () {
      return this.pageConfig['ipp_common_land4_img'] || ''
    }
  },
  async created () {
    this.channelCode =
      this.$route.query.channelNo ||
      this.$route.query.channelCode ||
      getCookie('channelCode')
    let channelNo =
      this.$route.query.channelNo ||
      this.$route.query.channelCode ||
      getCookie('channelCode')
    try {
      await this.getCustomChannel()
      if (this.customData) {
        return
      }
    } catch (e) {
      console.error(e)
    }
    this.customData = null
    this.getPageConfigList()
  },
  methods: {
    async getRegisterPackage () {
      try {
        const channelNo =
          this.$route.query.channelNo || this.$route.query.channelCode

        const { data } = await getRegisterAward({
          channelNo,
          deviceId: getDeviceId()
        })
        this.registerPackage = data || []
      } catch (e) {
        console.error(e)
      }
    },
    async getCustomChannel () {
      try {
        const channelNo =
          this.$route.query.channelNo || this.$route.query.channelCode

        const { data, code } = await getChannelPageConfig({
          channelNo,
          platform: 2
        })

        const { bannerH5, pageDetailH5 } = data || {}
        if (code === 0 && (bannerH5 || pageDetailH5)) {
          this.customData = data
          this.getRegisterPackage()
        } else {
          this.customData = null
        }
      } catch (e) {
        this.customData = null
        console.error(e)
      }
    },
    async getPageConfigList () {
      let res = await getPageConfigList({
        needParams: 'pageConfigList',
        pagePrefix: 'h5,ipp_common'
      }).catch(e => null)

      if (this.checkResponseIsErr(res)) {
        return
      }

      const pageConfigList = res.data.pageConfigList || []
      const pageConfig = {}

      pageConfigList.forEach(({ pageKey, pageValue }) => {
        pageConfig[pageKey] = pageValue
      })
      this.$store.commit('SET_PAGE_CONFIG', pageConfig)
    }
  }
}
</script>

<style lang="less">
#channel-page-html {
  img {
    width: 100%;
  }

  p {
    margin: 0;
  }
}
</style>

<style lang="less" scoped>
.land4 {
  padding-bottom: 143px;
}

.channel-code {
  position: fixed;
  right: 10px;
  top: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 10px;
  color: #cacaca;
  line-height: 14px;
}

.swiper {
  img {
    width: 100%;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/land4.vue